import { HttpClient } from '@angular/common/http';
import { DestroyRef, Inject, Injectable, inject } from '@angular/core';
import { WebPubSubClient } from '@azure/web-pubsub-client';
import { Subject, Subscription, firstValueFrom } from 'rxjs';
import { DeviceDto } from '../../dto/src/devices/device-dto';
import { RealTimeService } from '../real-time/real-time.service';
//import { Device } from '../../interfaces/device';

interface PubSubToken {
    pubSubUrl: string;
}

type NEW_DEVICES_PAYLOAD = {
    gatewayMacAddress: string;
    newDevices: DeviceDto[];
};

type FIRMWARE_PAYLOAD = {
    status: number;
    proggress: number;
};

type MEASUREMENTS_PAYLOAD = DeviceDto & any;

const groups = new Set<string>();

export function pubSubFactory(httpClient: HttpClient): WebPubSubClient {
    return new WebPubSubClient(
        {
            getClientAccessUrl: async () => {
                const { pubSubUrl } = await firstValueFrom(httpClient.get<PubSubToken>(`negotiate`));
                return pubSubUrl;
            }
        },
        { autoReconnect: true }
    );
}

@Injectable({
    providedIn: 'root'
})
export class PubSubService {
    private readonly destroyRef = inject(DestroyRef);

    private readonly firmwareUpdate = new Subject<FIRMWARE_PAYLOAD>();
    readonly firmwareUpdate$ = this.firmwareUpdate.asObservable();

    // private readonly newDevices = new Subject<NEW_DEVICES_PAYLOAD>();
    // readonly newDevices$ = this.newDevices.asObservable();

    private readonly measurements = new Subject<MEASUREMENTS_PAYLOAD>();
    readonly measurements$ = this.measurements.asObservable();

    private realTimeSubscription: Subscription;
    constructor(
        @Inject('AZURE_SERVICE_PUB_SUB_CLIENT')
        private readonly azurePubSubClient: WebPubSubClient,
        private realTimeService: RealTimeService
    ) {
        this.azurePubSubClient.start();
        this.azurePubSubClient.on('disconnected', console.log);
        this.destroyRef.onDestroy(() => this.azurePubSubClient.stop());
        // Subscribe to the observable to detect changes
        this.realTimeSubscription = this.realTimeService.realTime$.subscribe((value) => {
            if (value) {
                const id = value.locationId;
                this.joinGroup(id);
            }
        });
    }

    async leaveGroup(groupName: string) {
        if (!groups.has(groupName)) {
            return;
        }

        try {
            await this.azurePubSubClient.leaveGroup(groupName);
            this.azurePubSubClient.off('group-message', () => {});
            groups.delete(groupName);
        } catch (error) {
            console.error(`Failed to leave group: ${groupName}`, error);
        }
    }

    async leaveAllGroups() {
        groups.forEach(async (groupName: string) => {
            this.leaveGroup(groupName);
        }, groups);
    }

    private async joinGroup(id: any) {
        if (groups.has(`smarthink/v1/measurements/${id}`)) {
            return;
        }

        try {
            await this.azurePubSubClient?.joinGroup(`smarthink/v1/measurements/${id}`);
            groups.add(`smarthink/v1/measurements/${id}`);
            this.initListener(id);
        } catch (error) {
            console.error(`Failed to join location: ${id}`, error);
        }
    }

    // async stopClient() {
    //     if (this.azurePubSubClient) {
    //         try {
    //             this.azurePubSubClient.stop();
    //         } catch (error) {
    //             console.error(`Failed to stop client instance`, error);
    //         }
    //     }
    // }

    private initListener(id: any) {
        this.azurePubSubClient.on('group-message', (e: any) => {
            const { message } = e;
            // console.log('message', message);
            const payload = JSON.parse(message.data as string) as NEW_DEVICES_PAYLOAD;
            if (message.group === `smarthink/v1/measurements/${id}`) {
                this.measurements.next(payload);
            }
        });
    }
}
